/**
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {connect} from "react-redux";
import cx from "classnames";
import React from "react";
import PropTypes from "prop-types";
import {
  Navbar,
  Nav,
  NavItem,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import {NavLink} from "react-router-dom";

// import Icon from "../Icon";

import s from "./Header.module.scss";
import ChangePassword from "admin/views/Users/ChangePassword";
import {logout} from "admin/redux/actions/authAction";

class Header extends React.Component {
  static propTypes = {
    sidebarToggle: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    sidebarToggle: () => {},
  };

  state = {
    isOpen: false,
    modalOpen: false,
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render() {
    const {isOpen} = this.state;
    return (
      <Navbar className={s.root + " admin-nav header-layout"}>
        <Modal
          className="card-design"
          isOpen={this.state.modalOpen}
          toggle={() => this.setState({modalOpen: false})}>
          <ModalHeader className="card-header">
            <window.t>Change Password</window.t>
          </ModalHeader>
          <ModalBody className="card-body">
            <ChangePassword cancel={() => this.setState({modalOpen: false})} />
          </ModalBody>
        </Modal>
        <Nav xs="6">
          <NavItem
            className={cx(
              "visible-xs mr-4 d-sm-up-none",
              s.headerIcon,
              s.sidebarToggler,
            )}
            href="#"
            onClick={this.props.sidebarToggle}>
            <i className="fa fa-bars fa-2x text-muted" />
          </NavItem>
          <NavItem className="search-nav">
            <InputGroup>
              <Input placeholder="Search for..." />
              <InputGroupAddon addonType="append" className="px-2">
                <i className="fa fa-search" />
              </InputGroupAddon>
            </InputGroup>
          </NavItem>
        </Nav>
        <Nav className="ml-auto">
          {/* <NavItem className={cx("", s.headerIcon)}>
            <Button>
              <i className="fa fa-envelope fa-lg" />
              <span>8</span>
            </Button>
          </NavItem>
          <NavItem className={cx("", s.headerIcon)}>
            <Button>
              <i className="fa fa-bell fa-lg" />
              <span>13</span>
            </Button>
          </NavItem>
          <NavItem className={cx("", s.headerIcon)}>
            <Button>
              <i className="fa fa-cog fa-lg" />
            </Button>
          </NavItem> */}
          <Dropdown isOpen={isOpen} toggle={this.toggleDropdown}>
            <DropdownToggle nav>
              <img
                className={cx("rounded-circle mr-sm", s.adminPhoto)}
                src="/assets/images/logo.png"
                alt="administrator"
              />
              <span className="text-body">
                {this.props.authUser.firstName} {this.props.authUser.lastName}
              </span>
              <i
                className={cx("fa fa-angle-down ml-sm", s.arrow, {
                  [s.arrowActive]: isOpen,
                })}
              />
            </DropdownToggle>
            <DropdownMenu style={{width: "100%"}}>
              <DropdownItem>
                <span onClick={() => this.setState({modalOpen: true})}>
                  Change Password
                </span>
              </DropdownItem>
              <DropdownItem>
                <span onClick={() => this.props.dispatch(logout())}>
                  Logout
                </span>
              </DropdownItem>
              {/* <DropdownItem onClick={this.doLogout}>Logout</DropdownItem> */}
            </DropdownMenu>
          </Dropdown>
        </Nav>
      </Navbar>
    );
  }
}

function mapStateToProps(state) {
  return {
    init: state.runtime.initialNow,
    authUser: state.authUser,
  };
}
export default connect(mapStateToProps)(Header);
